/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as OrdersPageLoader } from './OrdersPage/OrdersPage.duck';
import { loadData as SalesPageLoader } from './SalesPage/SalesPage.duck';
import { loadData as AdminTransactionsPageLoader } from './AdminTransactionsPage/AdminTransactionsPage.duck';
import {
  loadData as AdminTransactionDetailPageLoader,
  setInitialValues as AdminTransactionDetailPageInitialValues,
} from './AdminTransactionDetailPage/AdminTransactionDetailPage.duck';
import { loadData as AdminUsersPageLoader } from './AdminUsersPage/AdminUsersPage.duck';
import { loadData as AdminUserDetailPageLoader } from './AdminUserDetailPage/AdminUserDetailPage.duck';
import { loadData as AdminAbandonedCartsPageLoader } from './AdminAbandonedCartsPage/AdminAbandonedCartsPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as CataloguePageLoader } from './CataloguePage/CataloguePage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as BlogListPageLoader } from './BlogListPage/BlogListPage.duck';
import { loadData as BlogPostPageLoader } from './BlogPostPage/BlogPostPage.duck';
import { loadData as ComparePageLoader } from './ComparePage/ComparePage.duck';
import { loadData as BundlesPageLoader } from './BundlesPage/BundlesPage.duck';
import { loadData as CagnotteFidelitePageLoader } from './CagnotteFidelitePage/CagnotteFidelitePage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    OrdersPage: {
      loadData: OrdersPageLoader,
    },
    SalesPage: {
      loadData: SalesPageLoader,
    },
    AdminTransactionsPage: {
      loadData: AdminTransactionsPageLoader,
    },
    AdminTransactionDetailPage: {
      loadData: AdminTransactionDetailPageLoader,
      setInitialValues: AdminTransactionDetailPageInitialValues,
    },
    AdminUsersPage: {
      loadData: AdminUsersPageLoader,
    },
    AdminUserDetailPage: {
      loadData: AdminUserDetailPageLoader,
    },
    AdminAbandonedCartsPage: {
      loadData: AdminAbandonedCartsPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    CataloguePage: {
      loadData: CataloguePageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    BlogListPage: {
      loadData: BlogListPageLoader,
    },
    BlogPostPage: {
      loadData: BlogPostPageLoader,
    },
    ComparePage: {
      loadData: ComparePageLoader,
    },
    BundlesPage: {
      loadData: BundlesPageLoader,
    },
    CagnotteFidelitePage: {
      loadData: CagnotteFidelitePageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
